import { createAction } from 'redux-act';
//////////////////////////////////////////////////

export const getConfigsByNamesRequest = createAction('getConfigsByNamesRequest');
export const getConfigsByNamesSuccess = createAction('getConfigsByNamesSuccess');
export const getCrossDockLocationsRequest = createAction('getCrossDockLocationsRequest');
export const getCrossDockLocationsSuccess = createAction('getCrossDockLocationsSuccess');
export const getDispatchBoardConfigsRequest = createAction('getDispatchBoardConfigsRequest');
export const getDispatchBoardConfigsSuccess = createAction('getDispatchBoardConfigsSuccess');
